import baseEN from './en/en_base.js'
import commonEN from './en/en_common.js'
import fogEN from './en/en_fog.js'
import homeEN from './en/en_home.js'
import memberEN from './en/en_member.js'
import publicEN from './en/en_public.js'
import searchEN from './en/en_search.js'
import settingEN from './en/en_setting.js'
import user_centralEN from './en/en_user_central.js'
import en_msg_codeEN from './en/en_msg_code.js'
import build_message from './build_message.js'
import genEN from './en/en_gen.js'

const messagesEn = build_message([
  genEN,
  baseEN,
  commonEN,
  fogEN,
  homeEN,
  memberEN,
  publicEN,
  searchEN,
  settingEN,
  user_centralEN,
  en_msg_codeEN,
])
export default messagesEn



// WEBPACK FOOTER //
// ./src/lan/en.js